<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <!-- TABLA DOCUMENTO -->
          <template>
            <div v-if="loading">
              <loading></loading>
            </div>
            <grid-reclutados
              :key="gridDocumento"
              :rowsTable="rowsTable"
              :contratoId="contratoId"
            ></grid-reclutados>
          </template>
          <!-- TABLA DOCUMENTO -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import GridReclutados from "@/modules/aplicacion/views/seleccion/candidatos/GridReclutados.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "candidatos-seleccion-tab",

  components: {
    GridReclutados,
    Loading,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      botonesUsuario: 0,
      gridDocumento: 20,
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
  },

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
  },
};
</script>
